/* eslint-disable react/prop-types */
import React from 'react';

import General from '../tabs/General/General';
import CustomerTab from './CustomerTab';

import Dialog from '@mui/material/Dialog';
import Accounting from '../tabs/Accounting/Accounting';
import clientService from '../../../services/ClientService';
import { toast } from 'react-hot-toast';
import Report from '../tabs/Report/Report';

import { Plugin, Template, TemplateConnector, TemplatePlaceholder } from '@devexpress/dx-react-core';
import Document from '../tabs/Document/Document';

export const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
  customerTabIndex,
  setCustomerTabIndex,
  onUpdateRow
}) => {
  return (
    <Dialog open={open} onClose={onCancelChanges} aria-labelledby="form-dialog-title" fullWidth maxWidth="lg">
      {/* Dialog contains tab and tab contents: CustomerTab is tab part */}
      <CustomerTab customerTabIndex={customerTabIndex} setCustomerTabIndex={setCustomerTabIndex} />

      {/* General and Accounting is the content of tab  */}
      {customerTabIndex === 0 && (
        <General row={row} onChange={onChange} onApplyChanges={onApplyChanges} onCancelChanges={onCancelChanges} />
      )}
      {customerTabIndex === 1 && (
        <Accounting
          row={row}
          onCancelChanges={onCancelChanges}
          setCustomerTabIndex={setCustomerTabIndex}
          onUpdateRow={onUpdateRow}
        />
      )}
      {customerTabIndex === 2 && (
        <Report row={row} onCancelChanges={onCancelChanges} setCustomerTabIndex={setCustomerTabIndex} />
      )}
      {customerTabIndex === 3 && (
        <Document row={row} onCancelChanges={onCancelChanges} setCustomerTabIndex={setCustomerTabIndex} />
      )}
    </Dialog>
  );
};

// eslint-disable-next-line react/display-name
export const PopupEditing = React.memo(
  ({ popupComponent: Popup, customerTabIndex, setCustomerTabIndex, onUpdateRow }) => (
    <Plugin>
      <Template name="popupEditing">
        <TemplateConnector>
          {(
            { rows, getRowId, addedRows, editingRowIds, createRowChange, rowChanges },
            {
              changeRow,
              changeAddedRow,
              commitChangedRows,
              commitAddedRows,
              stopEditRows,
              cancelAddedRows,
              cancelChangedRows
            }
          ) => {
            const isNew = addedRows.length > 0;
            let editedRow;
            let rowId;
            if (isNew) {
              rowId = 0;
              editedRow = addedRows[rowId];
            } else {
              [rowId] = editingRowIds;
              const targetRow = rows.filter((row) => getRowId(row) === rowId)[0];
              editedRow = { ...targetRow, ...rowChanges[rowId] };
            }

            const processValueChange = ({ target: { name, value } }) => {
              const changeArgs = {
                rowId,
                change: createRowChange(editedRow, value, name)
              };
              if (isNew) {
                changeAddedRow(changeArgs);
              } else {
                changeRow(changeArgs);
              }
            };
            const rowIds = isNew ? [0] : editingRowIds;
            const applyChanges = () => {
              if (isNew) {
                commitAddedRows({ rowIds });
              } else {
                stopEditRows({ rowIds });
                commitChangedRows({ rowIds });

                clientService
                  .updateCustomerFields(editedRow.id, rowChanges[rowId] || {})
                  .then(() => {
                    toast.success('Successfully updated customer in quickbook');
                  })
                  .catch((error) => {
                    toast.error('Could not update customer in quickbook' || error);
                  });
              }
            };
            const cancelChanges = () => {
              if (isNew) {
                cancelAddedRows({ rowIds });
              } else {
                stopEditRows({ rowIds });
                cancelChangedRows({ rowIds });
                setCustomerTabIndex(0);
              }
            };

            const open = editingRowIds.length > 0 || isNew;
            return (
              <Popup
                open={open}
                row={editedRow}
                onChange={processValueChange}
                onApplyChanges={applyChanges}
                onCancelChanges={cancelChanges}
                customerTabIndex={customerTabIndex}
                setCustomerTabIndex={setCustomerTabIndex}
                onUpdateRow={onUpdateRow}
              />
            );
          }}
        </TemplateConnector>
      </Template>
      <Template name="root">
        <TemplatePlaceholder />
        <TemplatePlaceholder name="popupEditing" />
      </Template>
    </Plugin>
  )
);
